export default __webpack_public_path__ + "static/media/yantramanav.black.50c30fff.ttf";